import { render, staticRenderFns } from "./Buscar_Institucion.vue?vue&type=template&id=24d254c3"
import script from "./Buscar_Institucion.vue?vue&type=script&lang=js"
export * from "./Buscar_Institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports